export enum InquiryCustomCakeFilling {
	FruityBright = "FruityBright",
	FruityDark = "FruityDark",
	LemonRaspberry = "LemonRaspberry",
	ChocoRaspberry = "ChocoRaspberry",
	Bueno = "Bueno",
	PistachioRaspberry = "PistachioRaspberry",
}
